import { INBODY_TYPES } from '../../../../../shared/constants/inbody-info/InbodyType';
import { SCAN_SOURCE_TYPE } from '../../../../constants/scanSourceType';
import { ScanMetadata } from '../../../../interfaces/scanMetadata';
//** We can't get inbody result sheet for H20B and manual scans */
export const getIsScanDisabled = (scan: ScanMetadata) => {
  return (
    scan.scanSourceType === SCAN_SOURCE_TYPE.MANUAL ||
    scan.inbodyType === INBODY_TYPES.H20B
  );
};
